import styled from '../../theme'

const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
`

export default ToastWrapper
